import styled from "styled-components";
export const GroupYachtBookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
